var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-button",class:[{ 'c-button--active': _vm.active }, ("c-button--" + _vm.mode)],on:{"click":function($event){return _vm.$emit('click', true)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }